import React from "react";
import { FaLinkedin, FaInstagram, FaFacebook, FaEnvelope, FaMedium } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

const Index = () => {
  const contactDetails = [
    {
      title: "LinkedIn",
      description: "Connect with us on LinkedIn.",
      link: "https://www.linkedin.com/company/commerceminder/",
      icon: <FaLinkedin className="text-4xl text-blue-600 mb-4 mx-auto" />,
    },
    {
      title: "Instagram",
      description: "Follow us for updates and more.",
      link: "https://instagram.com",
      icon: <FaInstagram className="text-4xl text-pink-500 mb-4 mx-auto" />,
    },
    {
      title: "Facebook",
      description: "Stay connected with us on Facebook.",
      link: "https://www.facebook.com/profile.php?id=61566345116436",
      icon: <FaFacebook className="text-4xl text-blue-800 mb-4 mx-auto" />,
    },
    {
      title: "Medium",
      description: "Stay connected with us on Medium.",
      link: "https://medium.com/@commerceminder",
      icon: <FaMedium className="text-4xl text-blue-800 mb-4 mx-auto" />,
    },
    {
      title: "Email",
      description: "Send us an email anytime.",
      link: "mailto:info@commerceminder.com",
      icon: <FaEnvelope className="text-4xl text-primary mb-4 mx-auto" />,
    },
    {
      title: "Address",
      description:
        "Gebze Osb Mah. Kemal Nehrozoglu Cad. No: 507 /2- İç Kapı No: - Gebze / Kocaeli",
      link: "https://www.google.com.tr/maps/",
      icon: <FaLocationDot className="text-4xl text-primary mb-4 mx-auto" />,
    },
  ];

  return (
    <section id="contact" className="py-10 md:py-52 px-4 w-full bg-gray-50">
      <div className="w-full mx-auto text-center">
        <h3 className="text-3xl font-bold mb-8 text-primary">Contact Us</h3>
        <p className="text-base text-gray-600 mb-6 max-w-xl mx-auto">
          Reach out to us through any of the platforms below! We're here to assist you.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {contactDetails.map((detail, index) => (
            <div
              key={index}
              className="p-5 bg-white rounded-lg shadow-lg hover:shadow-xl transition-transform transform hover:-translate-y-2 cursor-pointer text-center"
              onClick={() => window.open(detail.link, "_blank")}
            >
              <div className="mb-3">{detail.icon}</div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">{detail.title}</h4>
              <p className="text-sm text-gray-600">{detail.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Index;
